<template>
  <main>
    <div class="row d-flex flex-row px-0 mx-0">
      <div class="col-12 px-0">
        <!-- Mailbox infra -->
        <template v-if="itemSelected == 1">
          <div class="mt-3">
            <OwarmStats />
          </div>
        </template>

        <!-- Testing history  -->
        <template v-if="itemSelected == 2">
          <Deliverability />
        </template>

        <!-- Deliverability overview  -->
        <template v-if="itemSelected == 3">
          <DeliverabilityOverview />
        </template>

        <!-- Invoice Control  -->
        <template v-if="itemSelected == 4">
          <InvoiceControl />
        </template>

         <!-- List Delete domains  -->
         <template v-if="itemSelected == 5">
          <ListDeleteDomain />
        </template>

         <!-- List Renewal domains  -->
         <template v-if="itemSelected == 6">
          <ListRenewalDomain />
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import OwarmStats from "@/components/Infrastructure/OwarmStats.vue";
import Deliverability from "@/components/Infrastructure/Deliverability.vue";
import InvoiceControl from "@/components/Infrastructure/InvoiceControl.vue";
import ListDeleteDomain from "@/components/Infrastructure/ListDeleteDomain.vue";
import ListRenewalDomain from "@/components/Infrastructure/ListRenewalDomain.vue";
import DeliverabilityOverview from "@/components/Infrastructure/DeliverabilityOverview.vue";

import { mapState } from "vuex";

export default {
  data() {
    return {
      total: null,
      completeLoading: true,
      tabs: {
        1: {
          id: 1,
          name: "Mailbox infra",
          total: null,
        },
        2: {
          id: 2,
          name: "Testing history",
          total: null,
        },
        3: {
          id: 3,
          name: "Deliverability overview",
          total: null,
        },
        4: {
          id: 4,
          name: "Invoice control",
          total: null,
        },
        5: {
          id: 5,
          name: "Deleted domains",
          total: null,
        },
        6: {
          id: 6,
          name: "Domains renewal",
          total: null,
        },
      },
      itemSelected: 1,
    };
  },
  components: {
    OwarmStats,
    Deliverability,
    DeliverabilityOverview,
    InvoiceControl,
    ListDeleteDomain,
    ListRenewalDomain
  },

  created() {
    if (typeof this.$route.params.item !== "undefined") {
      this.itemSelected = this.$route.params.item;
      this.changeTab(this.itemSelected);
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
  },

  methods: {
    changeTab(index) {
      this.itemSelected = this.tabs[index].id;
      this.$emit("udpdateHeader", "allinfrastructure", this.tabs[index].name )
      this.key++;
    },
  },
};
</script>
